
import Vue from 'vue';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import labels from '@/store/labels';

export default Vue.extend({
  name: 'ChatMarkdown',
  props: {
    value: { type: String, required: true },
  },
  computed: {
    rendered(): string {
      const lookup = labels.getters.lookup;
      const source = (this.value || '')
        .replace(/#label:(\d+)(?:\[([^\]]*)\])?/g, (_, idStr: string, code?: string) => {
          const label = lookup.get(parseInt(idStr, 10));
          const display = code || label?.code || idStr;
          let style = '';
          if (label) {
            const { r, g, b } = label.color;
            const isDark = (r * 299 + g * 587 + b * 114) / 1000 <= 128;
            style = `background:rgb(${r},${g},${b});color:${isDark ? '#fff' : 'rgba(0,0,0,0.87)'}`;
          }
          return `<span class="ref-chip ref-chip--label" data-ref-type="label" data-ref-id="${idStr}" style="${style}">${display}</span>`;
        })
        .replace(/#document:(\d+)(?:\[([^\]]*)\])?/g, (_, idStr: string, name?: string) => {
          const display = name || idStr;
          return `<span class="ref-chip ref-chip--document" data-ref-type="document" data-ref-id="${idStr}">${display}</span>`;
        });
      const html = marked.parse(source) as string;
      return DOMPurify.sanitize(html, { ADD_ATTR: ['data-ref-type', 'data-ref-id', 'style'] });
    },
  },
  methods: {
    handleClick(e: MouseEvent) {
      const el = (e.target as HTMLElement).closest('[data-ref-type]') as HTMLElement | null;
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      this.$emit('refClick', {
        type: el.dataset.refType!,
        id: parseInt(el.dataset.refId!, 10),
      });
    },
  },
});
